import React from "react";
import { useIsDesktop } from "@/hooks/useMediaQuery";
import { PriceAlertsPageDesktop } from "./PriceAlertsPage.Desktop";
import { PriceAlertsPageMobile } from "./PriceAlertsPage.Mobile";

export const PriceAlertsPage: React.FC = () => {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <PriceAlertsPageDesktop />;
  }

  return <PriceAlertsPageMobile />;
};
